import config from "../config/environment";
import axios, { AxiosError, AxiosResponse } from "axios";

const axiosInterceptors = axios.create({
  baseURL: config.baseUrl,
  withCredentials: true,
  timeout: 10000,
});


axiosInterceptors.interceptors.response.use(
  (res) => res,
  (err) => {
    if (!err.response) {
      return Promise.reject(new Error("Network error, coba cek koneksi"));
    }
    return Promise.reject(err);
  }
);



export default axiosInterceptors;
